/* Wasatch Timber — PageFly variant picker auto-fix
   Prevents the drops-to-bare-product-URL dead end on multi-option products.
   - Greys out / blocks option values that can't form a real variant.
       * 2-option products: strict (an option is disabled if it has no variant
         with the other current selection) — never lets an invalid combo be picked.
       * 3+ option products: cascade (earlier options constrain later ones) so the
         top-level category (Type / Color) always stays selectable.
   - Safety net: if an invalid combination is ever selected, redirect to the
     nearest real variant instead of the bare product URL.
   Targets PageFly's .step-options / .step-option picker. No-ops elsewhere. */
(function () {
  function injectStyle() {
    if (document.getElementById('vp-style')) return;
    var st = document.createElement('style');
    st.id = 'vp-style';
    st.textContent = '.step-option.vp-unavailable{opacity:.35;pointer-events:none;cursor:not-allowed;}';
    (document.head || document.documentElement).appendChild(st);
  }

  function run() {
    var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    var groups = Array.prototype.slice.call(document.querySelectorAll('.step-options'));
    if (!meta || !meta.variants || !meta.variants.length || groups.length < 2) return false;

    var VV = meta.variants.map(function (v) { return { id: v.id, o: (v.public_title || '').split(' / ').map(function (s) { return s.trim(); }) }; });
    var nPos = VV[0].o.length;
    var posVals = [];
    for (var p = 0; p < nPos; p++) posVals[p] = VV.map(function (r) { return r.o[p]; });

    // set of every real option value, used to resolve a swatch/chip to its true value
    var ALL = {};
    posVals.forEach(function (arr) { arr.forEach(function (v) { ALL[v] = 1; }); });

    function optEls(g) { return Array.prototype.slice.call(g.querySelectorAll('.step-option')); }
    // Some pickers (color swatches) render the label twice, so textContent comes back
    // doubled. Resolve against the real variant values: exact, de-duplicated, longest prefix.
    function optVal(o) {
      var t = (o.textContent || '').trim().replace(/\s+/g, ' ');
      if (ALL[t]) return t;
      var half = t.slice(0, Math.floor(t.length / 2));
      if (half && t === half + half && ALL[half]) return half;
      var best = null;
      for (var k in ALL) { if (t.indexOf(k) === 0 && (!best || k.length > best.length)) best = k; }
      return best || t;
    }

    var groupPos = groups.map(function (g) {
      var texts = optEls(g).map(optVal), best = 0, bestScore = -1;
      for (var p = 0; p < nPos; p++) {
        var set = posVals[p];
        var score = texts.filter(function (x) { return set.indexOf(x) >= 0; }).length;
        if (score > bestScore) { bestScore = score; best = p; }
      }
      return best;
    });

    function selVals() {
      var s = []; for (var p = 0; p < nPos; p++) s[p] = null;
      groups.forEach(function (g, gi) { var e = g.querySelector('.step-option.is-selected'); if (e) s[groupPos[gi]] = optVal(e); });
      return s;
    }
    function match(r, c) { for (var p = 0; p < nPos; p++) { if (c[p] != null && r.o[p] !== c[p]) return false; } return true; }
    function exists(c) { return VV.some(function (r) { return match(r, c); }); }
    function firstVariant(c) { return VV.filter(function (r) { return match(r, c); })[0]; }

    var strict = (nPos === 2);
    function constraintFor(sel, p, v) {
      var c = [];
      for (var q = 0; q < nPos; q++) { c[q] = (q === p) ? v : (strict ? sel[q] : (q < p ? sel[q] : null)); }
      return c;
    }

    var busy = false;
    function recompute() {
      busy = true;
      var sel = selVals();
      groups.forEach(function (g, gi) {
        var p = groupPos[gi];
        optEls(g).forEach(function (o) {
          var v = optVal(o);
          var ok = o.classList.contains('is-selected') || exists(constraintFor(sel, p, v));
          o.classList.toggle('vp-unavailable', !ok);
        });
      });

      // safety net: invalid full selection -> jump to nearest real variant
      var full = true; for (var p = 0; p < nPos; p++) { if (sel[p] == null) { full = false; break; } }
      if (full && !exists(sel)) {
        var prev = window.__vpPrev || sel, changed = 0;
        for (var i = 0; i < nPos; i++) { if (sel[i] !== prev[i]) { changed = i; break; } }
        var c = []; for (var q = 0; q < nPos; q++) c[q] = (q <= changed ? sel[q] : null);
        var tv = firstVariant(c);
        if (!tv) { var d = []; for (var q2 = 0; q2 < nPos; q2++) d[q2] = (q2 === changed ? sel[q2] : null); tv = firstVariant(d); }
        if (tv) { var u = new URL(location.href); u.searchParams.set('variant', tv.id); window.location.href = u.toString(); return; }
      }

      window.__vpPrev = sel;
      setTimeout(function () { busy = false; }, 0);
    }

    recompute();
    if (!window.__vpObs) {
      window.__vpObs = new MutationObserver(function (m) {
        if (busy) return;
        for (var i = 0; i < m.length; i++) {
          var t = m[i].target;
          if (t.classList && t.classList.contains('step-option')) { recompute(); return; }
        }
      });
      window.__vpObs.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    return true;
  }

  function boot() {
    injectStyle();
    var tries = 0;
    (function wait() { if (run()) return; if (tries++ < 30) setTimeout(wait, 200); })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
